import { render, staticRenderFns } from "./Menu2.vue?vue&type=template&id=77bc05b6&scoped=true"
import script from "./Menu2.vue?vue&type=script&lang=js"
export * from "./Menu2.vue?vue&type=script&lang=js"
import style0 from "./Menu2.vue?vue&type=style&index=0&id=77bc05b6&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc05b6",
  null
  
)

export default component.exports